import { Link } from "react-router-dom";
import { Col } from "reactstrap";
import { H3, Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import { Boho } from "../../../Constant";
import { useAppSelector } from "../../../Redux-Toolkit/Hooks";

const InvoiceHeaderCol = () => {
  const{mix_background_layout} = useAppSelector((state) => state.themeCustomizer)

  return (
    <Col sm="6">
      <div className="d-flex">
        <div className="d-flex-left">
          <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
            <Image className="d-flex-object img-60" src={dynamicImage(`${mix_background_layout === "dark-only" ? "logo/logo-w.png" : "other-images/logo-login.png"}`)} alt="other"/>
          </Link>
        </div>
        <div className="flex-grow-1 m-l-20">
          <H3 className="media-heading f-w-600 mb-0">{Boho}</H3>
          <P>hello@Boho.in<br /><span className="digits">89-335-6503</span></P>
        </div>
      </div>
    </Col>
  );
};

export default InvoiceHeaderCol;
